const initRedirects = () => {
  (function () {
    var anchorMap = [
      '/home/default.aspx',
      '/who-we-are/default.aspx',
      '/who-we-are/default.aspx#section=map',
      '/who-we-are/default.aspx#section=history',
      '/who-we-are/default.aspx#section=values',
      '/who-we-are/default.aspx#section=community',
      '/who-we-are/default.aspx#section=executive',
      '/what-we-do/default.aspx',
      '/what-we-do/default.aspx#section=supply',
      '/what-we-do/default.aspx#section=technology',
      '/careers/default.aspx',
      '/careers/default.aspx#section=employees',
      '/careers/default.aspx#section=development',
      '/careers/default.aspx#section=diversity',
      '/careers/default.aspx#section=benefits',
      '/newsroom/default.aspx',
    ];

    var newLinks = [
      '/',
      '/our-company/',
      '/our-company/',
      '/our-company/',
      '/our-company/',
      '/community-strong/',
      '/our-company/',
      '/what-we-do/',
      '/logistics/',
      '/what-we-do/',
      '/join-us/',
      '/join-us/',
      '/join-us/',
      '/join-us/',
      '/join-us/',
      '/newsroom/',
    ];

    anchorMap.forEach(function (value, key) {
      if (window.location.hash === '') {
        if (window.location.pathname === value) {
          window.location.href = newLinks[key];
        }
      } else {
        if (window.location.pathname + window.location.hash === value) {
          window.location.href = newLinks[key];
        }
      }
    });
  })();
};

export default initRedirects;
